<script>
import {deepClone} from '@lsfe/tools';

export default {
    props: {
        icon: {
            type: String
        }
    },
    inject: ['levelSelect'],
    data() {
        return {
            inputWidth: 0,
            keyword: ''
        };
    },
    computed: {
        tagsCount() {
            const {showTags} = this.levelSelect;
            if (typeof showTags === 'number') {
                return showTags;
            }
            return 5;
        },
        tagsData() {
            return this.levelSelect.store.selectedValue;
        },
    },
    methods: {
        renderTag() {
            return (this.tagsData.slice(0, this.tagsCount)).map(item => {
                return <el-tag
                    size="small"
                    key={item.id}
                    disable-transitions={true}
                    closable={!this.levelSelect.innerDisabled}
                    onClose={() => this.deleteOneData(item)}
                >{item.label}</el-tag>;
            });
        },
        handleClick() {
            const { innerDisabled } = this.levelSelect;
            if (innerDisabled && this.tagsData.length <= this.tagsCount) {
                // 如果disabled并且选中数量小于1
                return;
            }
            this.levelSelect.popoverVisible = true;
            this.levelSelect.shouldTrigger = true;
        },
        deleteOneData(item) {
            this.levelSelect.store.handleCheck(false, item, false);
            this.levelSelect.emitChange();
            this.levelSelect.emitCheck(false, deepClone(item));
        },
        handleClear() {
            this.$emit('clear');
        }
    },
    render(h) {
        const {innerDisabled, popoverVisible} = this.levelSelect;
        return (
            <div
                ref="tagWrapper"
                class={`${innerDisabled ? 'is-disabled' : ''} ${popoverVisible && !innerDisabled ? 'is-focus' : ''} tag-wrapper el-input el-input--${this.$attrs.size}`}
                onClick={this.handleClick}
            >
                <span class="el-input__inner">
                    <span class="tag-wrapper__inner">
                        {this.renderTag(h)}
                        {this.tagsData.length <= this.tagsCount ? '' : (<el-tag
                            size="small"
                            key="extend"
                            disable-transitions={true}
                            closable={false}
                        >+{this.tagsData.length - this.tagsCount}</el-tag>)}
                    </span>
                    <i class={`icon-wrapper ${this.icon}`} onClick={this.handleClear}></i>
                </span>
            </div>
        );
    }
};
</script>
<style lang="scss" scoped>
.tag-wrapper {
    width: 330px;
    .el-input__inner {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: auto;
        padding: 0 5px;
        min-width: 180px;
        .tag-wrapper__inner {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            flex: 1;
            .el-tag {
                height: 20px;
                margin: 2px 0 2px 1px;
                line-height: 20px;
                border-radius: 2px;
                padding: 0 4px;
                /deep/.el-icon-close:hover {
                    background-color: rgba(0, 0, 0, 0);
                    color: #409eff;
                }
            }
        }
        .icon-wrapper {
            flex: 0 0 auto;
            width: 25px;
            cursor: pointer;
            color: #c0c4cc;
        }
        &:hover {
            .close-icon {
                display: inline-block;
            }
        }
    }
}
</style>
